import React, { PropTypes } from 'react';
import ManipButtons from '../ManipButtons';

const formatCaptures = (manip, otherPestsRef) => {
  const selectedSpecies = manip.species.map(s => Number.parseInt(s, 10));
  const species = manip.species_captures
    .map(cap => {
      const otherPestsId = Number.parseInt(cap.species, 10);
      const capture = Number.parseInt(cap.value, 10);

      if (otherPestsRef) {
        const otherPest = otherPestsRef.find(i => i.id === otherPestsId);

        if (
          otherPest &&
          capture !== undefined &&
          capture !== null &&
          !isNaN(capture) &&
          selectedSpecies.includes(otherPestsId)
        ) {
          return `${otherPest.label} : ${capture}<br />`;
        } else if (otherPest && selectedSpecies.includes(otherPestsId)) {
          return `${otherPest.label}<br />`;
        }
      }

      return '';
    })
    .join('');

  let other = '';
  const otherCapture = manip.species_other_capture;

  if (
    manip.species_other &&
    otherCapture !== undefined &&
    otherCapture !== null
  ) {
    other = `${manip.species_other} : ${otherCapture}`;
  } else if (manip.species_other) {
    other = `${manip.species_other} `;
  }
  const result = species + other;

  return {
    __html: result,
  };
};

const OtherPestsItem = ({
  manip,
  onUpdated,
  onDeleted,
  _,
  capturesRef,
  otherPestsRef,
  disabled = false,
}) => (
  <tr>
    <ManipButtons
      manip={manip}
      onUpdated={onUpdated}
      onDeleted={onDeleted}
      hideHistory={false}
      disabled={disabled}
    />
    <td>{manip.number}</td>
    <td>{manip.product_name}</td>
    <td>{manip.manip_name}</td>
    <td>{manip.comp_product_name}</td>
    <td>{manip.comp_manip_name}</td>
    <td dangerouslySetInnerHTML={formatCaptures(manip, otherPestsRef)} />
  </tr>
);

OtherPestsItem.propTypes = {
  manip: PropTypes.object.isRequired,
  onUpdated: PropTypes.func.isRequired,
  onDeleted: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default OtherPestsItem;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/types/OtherPestsItem.js